export default __webpack_public_path__ + "static/media/hamburger-icon.b8e631d2.svg";